let googleLoaded = false;
let facebookLoaded = false;

export function loadGoogleSignIn(): Promise<void> {
  if (googleLoaded) return Promise.resolve();
  return new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = 'https://accounts.google.com/gsi/client';
    script.onload = () => { googleLoaded = true; resolve(); };
    script.onerror = () => reject(new Error('Nie udało się załadować Google Sign-In'));
    document.head.appendChild(script);
  });
}

export function loadFacebookSDK(appId: string): Promise<void> {
  if (facebookLoaded) return Promise.resolve();
  return new Promise((resolve, reject) => {
    (window as any).fbAsyncInit = () => {
      FB.init({ appId, cookie: true, xfbml: false, version: 'v19.0' });
      facebookLoaded = true;
      resolve();
    };
    const script = document.createElement('script');
    script.src = 'https://connect.facebook.net/pl_PL/sdk.js';
    script.async = true;
    script.defer = true;
    script.onerror = () => reject(new Error('Nie udało się załadować Facebook SDK'));
    document.head.appendChild(script);
  });
}
